import React, { useContext, useMemo, useState, Component, useEffect } from 'react';
import { Row } from '@digital/ui';
import { Card } from 'antd';

interface TotalizadorProps {
  valoresMedicaoAnterior: string;
  valoresMedicaoPeriodo: string;
  valoresMedicaoAcumulado: string;
  valoresContratoCriacaoMedicao: string;
  valoreMedicaoSaldo: string;
}

const TotalizadorMedicao = (props: TotalizadorProps) => {
  const {
    valoresMedicaoAnterior,
    valoresMedicaoPeriodo,
    valoresMedicaoAcumulado,
    valoresContratoCriacaoMedicao,
    valoreMedicaoSaldo,
  } = props;

  return (
    <div id={'div-totalizador'}>
      <div className="cards-boletim-medicao">
        <Row style={{ display: 'flex' }}>
          <Card style={{ width: '20%', marginLeft: '5px', marginRight: '5px' }} title="Anterior" bordered={false}>
            {valoresMedicaoAnterior}
          </Card>
          <Card style={{ width: '20%', marginLeft: '5px', marginRight: '5px' }} title="Período" bordered={false}>
            {valoresMedicaoPeriodo}
          </Card>
          <Card style={{ width: '20%', marginLeft: '5px', marginRight: '5px' }} title="Acumulado" bordered={false}>
            {valoresMedicaoAcumulado}
          </Card>
          <Card
            style={{ width: '20%', marginLeft: '5px', marginRight: '5px' }}
            title="Valor do Contrato"
            bordered={false}>
            {valoresContratoCriacaoMedicao}
          </Card>
          <Card style={{ width: '20%', marginLeft: '5px', marginRight: '5px' }} title="Saldo" bordered={false}>
            {valoreMedicaoSaldo}
          </Card>
        </Row>
      </div>
    </div>
  );
};

export default TotalizadorMedicao;
